import graphql from "babel-plugin-relay/macro";

export const QUERY_FRAGMENT = graphql`
	fragment moduleRatingsTable_RefetchableQueryFragment on Query
	@refetchable(queryName: "moduleRatingsTable_Refetch")
	@argumentDefinitions(
		first: { type: "Int" }
		after: { type: "String" }
		value: { type: "BigDecimalRangeFilter" }
	) {
		Admin {
			ModuleRating {
				ModuleRatingCalculations(first: $first, after: $after, value: $value)
					@connection(key: "moduleRatingsTable_ModuleRatingCalculations") {
					edges {
						node {
							...moduleRatingsTable_ModuleRatingCalculationInlineFragment
						}
					}
				}
			}
		}
	}
`;

export const MODULE_RATING_CALCULATIONS_INLINE_FRAGMENT = graphql`
	fragment moduleRatingsTable_ModuleRatingCalculationInlineFragment on ModuleRatingCalculation
	@inline {
		nodeRef
		node {
			id
			structureDefinition {
				title
			}
		}
		amount
		score
	}
`;
